import { useEffect } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';

import Breadcrumbs from '@/components/Breadcrumbs';
import { useSelectedTenant } from '@/hooks/useSwr';

const Prompts = () => {
  const selectedTenant = useSelectedTenant();
  const tenant = selectedTenant.data;
  const orgId = tenant?.id;
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (orgId && !searchParams.has('organizationId')) {
      // Preserve existing params while adding organizationId
      const newParams = new URLSearchParams(searchParams);
      newParams.set('organizationId', orgId);
      setSearchParams(newParams);
    }
  }, [orgId, searchParams, setSearchParams]);

  return (
    <div className="flex h-screen flex-col">
      <div className="px-4 pt-3">
        <Breadcrumbs />
      </div>

      <Outlet />
    </div>
  );
};

export default Prompts;
